module.exports = __webpack_public_path__ + "img/Stay_On_Page.1d3b0ec3.svg";